/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { IntegratedTourType } from '@zcode/enums'
import type { Property } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { useMemo } from 'react'
import { useGetTourIntegration } from '../useGetTourIntegration'

export const useTourTypeOptions = (
  entity:
    | MaybeEmpty<Pick<Property, 'groupId' | 'isTourDisabled' | 'mightHaveInstantTourScheduling'>>
    | null
    | undefined,
  skip?: boolean
) => {
  const { data, fetching } = useGetTourIntegration(entity, skip)
  return useMemo(() => {
    if (entity?.isTourDisabled) {
      return { fetching: false, tourTypeOptions: [] }
    }
    if (data) {
      return {
        fetching,
        tourTypeOptions: data.tourTypes,
      }
    }
    if (fetching) {
      return { fetching, tourTypeOptions: [] }
    }
    return {
      fetching,
      tourTypeOptions: [IntegratedTourType.AGENT_GUIDED],
    }
  }, [data, entity, fetching])
}
